export function isValidEmail (raw: string): boolean {
  if (raw.trim().length === 0) {
    return false
  }

  const regexValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)
  return regexValidEmail
}
